import PageGame from '@/components/PageGame';

export default PageGame;

export async function getStaticProps() {
  return {
    props: {
      path: '/keno/spielen',
      game: 'Keno',
      description:
        'KENO online spielen ✓: Mit dem Spielschein den Spieleinsatz und KENO-Typ wählen und sicher bei Ihrer Landeslotteriegesellschaft abgeben!',
      seoDescription:
        'Ihr Spielschein für die tägliche Zahlenlotterie KENO: Zahlen und KENO-Typ individuell oder per Quick-Tipp ankreuzen, Spieleinsatz, Zusatzlotterie plus 5, Ziehungen wählen und KENO online bei Ihrer Landeslotteriegesellschaft spielen.',
      title: 'KENO spielen ► Online-Spielschein',
      seoHeadline: 'KENO | LOTTO.de - Spielen beim Original!',
      gameKeno: 'standard',
    },
  };
}
